import React from "react";

type Props = {
  name: string;
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  disabled?: boolean;
};

const OPTIONS: { label: string; value: boolean | null }[] = [
  { label: "(not set)", value: null },
  { label: "True", value: true },
  { label: "False", value: false },
];

export const BooleanField: React.FC<Props> = ({
  name,
  value,
  onChange,
  disabled,
}) => {
  const currentValue = value ?? null;
  return (
    <div className="tw-flex tw-items-center tw-gap-4">
      {OPTIONS.map((option) => (
        <label
          key={option.label}
          className={`tw-flex tw-items-center tw-gap-1 tw-text-sm ${
            disabled
              ? "tw-cursor-not-allowed tw-text-gray-500"
              : "tw-cursor-pointer tw-text-gray-700"
          }`}
        >
          <input
            type="radio"
            name={name}
            checked={currentValue === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
            className="tw-form-radio tw-h-4 tw-w-4
              tw-border-gray-400 tw-text-blue-600
              focus:tw-ring-2 focus:tw-ring-blue-500
              disabled:tw-border-gray-200 disabled:tw-text-gray-200 disabled:tw-cursor-not-allowed"
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};
